<template>
    <div class="page">
        <van-form class="form" @submit="onSubmit">
            <div>
                <van-field
                    v-model="info.name"
                    name="收货人"
                    label="收货人"
                    placeholder="请输入收货人姓名"
                    :rules="[{ required: true, message: '请输入收货人姓名' }]"
                />
                <van-field
                    v-model="info.phone"
                    name="联系电话"
                    label="联系电话"
                    placeholder="请输入联系电话"
                    type="tel"
                    :rules="[{ required: true, message: '请输入联系电话' }]"
                />
                <van-field
                    readonly
                    clickable
                    name="picker"
                    :value="info.areaStr"
                    label="收货地址"
                    placeholder="请选择省/市/区"
                    @click="showPicker = true"
                    :rules="[{ required: true, message: '请选择省/市/区' }]"
                />
                <van-popup v-model="showPicker" position="bottom">
                    <van-area
                        title="请选择省/市/区"
                        :area-list="areaList"
                        @confirm="selCity($event)"
                        @cancel="showPicker = false"
                    />
                </van-popup>
                <van-field
                    v-model="info.address"
                    name="详细地址"
                    label="详细地址"
                    placeholder="请输入详细地址"
                    :rules="[{ required: true, message: '请输入详细地址' }]"
                />
                <div class="sm">
                    说明：您所填写的个人信息将仅用于邮寄礼品之用，我们会严格做好保密工作。
                </div>
            </div>
            <div class="btn-box">
                <van-button
                    class="submit"
                    round
                    block
                    type="info"
                    native-type="submit"
                >
                    提交
                </van-button>
            </div>
        </van-form>
    </div>
</template>

<script>
    import areaList from "../../citys.js";
    import userInvertigateService from "../../service/user-investigate.service";
    import { UserInvestigate } from "../../types/user-investigate";
    import { Toast } from "vant";
    export default {
        name: "user-investigate",
        data() {
            return {
                showPicker: false,
                areaList,
                info: new UserInvestigate(),
                loading: false,
                activityId: undefined,
            };
        },
        created() {
            this.activityId = this.$route.query.activityId;
            this.getMyAddressTemp();
        },

        methods: {
            selCity(e) {
                this.info.areaStr = `${e[0].name}/${e[1].name}/${e[2].name}`;
                this.showPicker = false;
                this.info.area.province = e[0].name;
                this.info.area.city = e[1].name;
                this.info.area.country = e[2].name;
            },
            getMyAddressTemp() {
                userInvertigateService
                    .getMyAddressTemp({ activityId: this.activityId })
                    .then((res) => {
                        if (res.data.id) {
                            this.info = res.data;
                        }
                    });
            },
            onSubmit() {
                if (this.loading) {
                    return;
                }
                this.loading = true;
                userInvertigateService
                    .doEditAddressTemp({
                        activityId: this.activityId,
                        ...this.info,
                    })
                    .then(() => {
                        Toast("提交成功");
                        this.loading = false;
                        setTimeout(() => {
                            this.$router.push("/index");
                        }, 1000);
                    })
                    .catch(() => {
                        this.loading = false;
                    });
            },
        },
    };
</script>

<style lang="scss" scoped src="./user-investigate.scss"></style>
